import { render, staticRenderFns } from "./PlatingRow.vue?vue&type=template&id=4f8f2373&"
import script from "./PlatingRow.vue?vue&type=script&lang=js&"
export * from "./PlatingRow.vue?vue&type=script&lang=js&"
import style0 from "./PlatingRow.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports